import { useEffect, useState } from 'react';

const matches = (query) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return Boolean(window.matchMedia(query)?.matches);
  } catch {
    return false;
  }
};

/** Live `window.matchMedia(query).matches` (false where matchMedia is missing). */
const useMediaQuery = (query) => {
  const [value, setValue] = useState(() => matches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    let mql;
    try {
      mql = window.matchMedia(query);
    } catch {
      return undefined;
    }
    if (!mql) return undefined;
    const onChange = (event) => setValue(Boolean(event.matches));
    setValue(Boolean(mql.matches));
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    if (typeof mql.addListener === 'function') {
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    }
    return undefined;
  }, [query]);

  return value;
};

export default useMediaQuery;
